import React from 'react';
import { ALIGN_TYPE } from '@zmedia/bm-soccer-ui/constants';
import { IBaseSection, IContent } from '@zmedia/bm-soccer-ui/interface';
import ContentMoreSection from './ContentMoreSection';
import styles from './style.module.scss';

interface IProps extends IBaseSection<IContent> {
    className?: string;
    alignList?: ALIGN_TYPE;
    alignItem?: ALIGN_TYPE;
    hasLayoutPhoto?: boolean;
    ComponentList?: React.FunctionComponent<any>;
    ComponentListProps?: any;
    ComponentEmpty?: React.FunctionComponent<any>;
    title?: string;
    children?: React.ReactNode;
    showSapo?: boolean;
    name?: string;
}

export default React.memo(function ContentSection(props: IProps) {
    return (
        <ContentMoreSection
            {...props}
            className={styles['content-section']}
        />
    );
});
